import React, {useEffect} from "react";
import styled from "@yb/styled-px2rem";

export interface PopupProps {
	open: boolean;
	title: string;
	children?: React.ReactNode;
	onClose: () => void;
}

const Overlay = styled.div<{$open: boolean}>`
	position: fixed;
	inset: 0;
	z-index: 110;
	display: ${({$open}) => ($open ? "flex" : "none")};
	align-items: flex-start;
	overflow-y: auto;
	background-color: rgba(26, 26, 26, 0.5);
`;

const InnerWrap = styled.div`
	min-height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px 0;
	box-sizing: border-box;
`;

const Container = styled.div`
	width: 480px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;

	@media (max-width: 510px) {
		width: calc(100% - min(7.6923vw, 3rem));
	}
`;

const Header = styled.div`
	display: flex;
	height: 56px;
	padding: 20px 24px 6px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 16px 16px 0 0;
	background-color: #fff;
	box-sizing: border-box;

	> h2 {
		line-height: 1.5;
		font-size: 20px;
		font-family: "PT-semibold";
		color: var(--title-color);
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
`;

const Content = styled.div`
	border-radius: 0 0 16px 16px;
	background-color: #fff;
`;

export const PopupButtonWrap = styled.div`
	display: flex;
	width: 100%;
	border-radius: 0 0 16px 16px;
	overflow: hidden;
	background-color: #fff;
`;

export const PopupButton = styled.button<{types: "cancle" | "submit"}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 50px;
	border-top: 1px solid var(--border-color);
	font-size: 16px;

	&:disabled {
		cursor: not-allowed;
		background-color: var(--disable-bg-color);
		color: var(--disable-text-color);
		border-color: var(--disable-line-color);
	}

	${({types}) => {
		if (types === "cancle") {
			return `
	      font-family: "PT-medium";
        background-color:#fff;
	      border-color: var(--hr-color);
        color: var(--caption-color);
        `;
		}
		if (types === "submit") {
			return `
	      font-family: "PT-semibold";
        background-color:var(--brand-color);
	      border-color: var(--brand-color);
        color: var(--title-color);
      `;
		}
	}}
`;

const PopupConfirm = ({open, title, children, onClose}: PopupProps) => {
	// body scroll lock
	useEffect(() => {
		if (!open) return;

		const {overflow, touchAction} = document.body.style;

		document.body.style.overflow = "hidden";
		document.body.style.touchAction = "none";

		return () => {
			document.body.style.overflow = overflow;
			document.body.style.touchAction = touchAction;
		};
	}, [open]);

	if (!open) return null;

	return (
		<Overlay $open={open}>
			<InnerWrap onClick={e => e.target === e.currentTarget && onClose()}>
				<Container>
					<Header>
						<h2>{title}</h2>
					</Header>
					<Content>{children}</Content>
				</Container>
			</InnerWrap>
		</Overlay>
	);
};

export default PopupConfirm;
